import React from "react";

import Container from "react-bootstrap/Container";

import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import SearchBar from "../../common/components/SearchBar";

export default function ExercisesHeader({ onSearchChange, disabled }) {
  return (
    <NavbarResponsive>
      <Container style={{ width: "100%", display: "block" }}>
        <SearchBar
          onChange={onSearchChange}
          placeholder="Cerca per nome"
          addButton={false}
          disabled={disabled}
          avatar
        />
      </Container>
    </NavbarResponsive>
  );
}
